<template>
    <div class="slider-default _portfolio section" v-if="sliderItems">
        <div class="container">
            <div class="slider-default__static section-margin">
                <h2 class="title slider-default__static-title">
                    Удивим проектами из&nbsp;портфолио
                </h2>
                <div class="slider-default__static-text">
                    <a
                        v-for="sliderItem of sliderItems"
                        class="link _underline"
                        :href="sliderItem.url"
                    >
                        <span>{{ sliderItem.name }}</span>
                        <svg viewBox="0 0 13 20">
                            <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5" />
                        </svg>
                    </a>
                </div>
            </div>
            <div class="section-promo">
                <VueSlickCarousel
                    class="slider-default__promo-slider slider"
                    ref="promo"
                    v-bind="slickPortfolioOptionsText"
                    @beforeChange="syncSliders"
                >
                    <div
                        class="slider-default__item"
                        v-for="sliderItem of sliderItems"
                    >
                        <p class="section-promo__title sub-title">
                            {{ sliderItem.name }}
                        </p>
                        <p class="section-promo__text">{{ sliderItem.text }}</p>
                    </div>
                </VueSlickCarousel>

                <div class="section-promo__numbers">
                    <div class="section-promo__number">
                        <span>250 тыс.</span>изделий
                    </div>
                    <div class="section-promo__number">
                        <span>50 000</span>клиентов
                    </div>
                    <div class="section-promo__number">
                        <span>1 год</span>гарантия
                    </div>
                </div>
            </div>

            <VueSlickCarousel
                class="slider-default__img-slider slider"
                v-if="window.width > 994"
                ref="img"
                v-bind="slickPortfolioOptionsImg"
                @beforeChange="syncSliders"
            >
                <div
                    class="slider-default__img-slider-item"
                    v-for="sliderItem of sliderItems"
                >
                    <div
                        class="slider-default__img-slider-inner"
                        v-for="portfolioImage in sliderItem.portfolioImages"
                    >
                        <img
                            class="slider-default__img-slider-img"
                            :src="portfolioImage"
                            :alt="sliderItem.name + ' фото проекта'"
                        />
                    </div>
                </div>
                <template #prevArrow="arrowOption">
                    <button type="button" class="slick-arrow _prev">
                        <svg class="icon-arrow">
                            <use xlink:href="#arrow-slider" />
                        </svg>
                    </button>
                </template>
                <template #nextArrow="arrowOption">
                    <button type="button" class="slick-arrow _next">
                        <svg class="icon-arrow">
                            <use xlink:href="#arrow-slider" />
                        </svg>
                    </button>
                </template>
            </VueSlickCarousel>

            <VueSlickCarousel
                class="slider-default__img-slider slider"
                v-if="window.width <= 994"
                ref="img"
                v-bind="slickPortfolioOptionsImgMobile"
                @beforeChange="syncSliders"
            >
                <div
                    class="slider-default__img-slider-wrapper"
                    v-for="sliderItem of sliderItems"
                >
                    <img
                        class="slider-default__img-slider-img"
                        :src="sliderItem.portfolioImages[1]"
                        :alt="sliderItem.name + ' фото проекта'"
                    />
                </div>
                <template #prevArrow="arrowOption">
                    <button type="button" class="slick-arrow _prev">
                        <svg class="icon-arrow">
                            <use xlink:href="#arrow-slider" />
                        </svg>
                    </button>
                </template>
                <template #nextArrow="arrowOption">
                    <button type="button" class="slick-arrow _next">
                        <svg class="icon-arrow">
                            <use xlink:href="#arrow-slider" />
                        </svg>
                    </button>
                </template>
            </VueSlickCarousel>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
    name: 'portfolioSlider',
    components: { VueSlickCarousel },
    data() {
        return {
            slickPortfolioOptionsText: {
                arrows: false,
                fade: true,
                infinite: true,
                asNavFor: this.$refs.img,
            },
            slickPortfolioOptionsImg: {
                arrows: false,
                dots: true,
                fade: true,
                infinite: true,
                adaptiveHeight: true,
                lazyLoad: 'ondemand',
                asNavFor: this.$refs.promo,
            },
            slickPortfolioOptionsImgMobile: {
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: false,
                dots: true,
                fade: true,
                infinite: true,
                adaptiveHeight: true,
                lazyLoad: 'ondemand',
                asNavFor: this.$refs.promo,
            },
            sliderItems: null,
            window: {
                width: 0,
            },
        };
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
        },
        syncSliders(currentPosition, nextPosition) {
            this.$refs.img.goTo(nextPosition);
            this.$refs.promo.goTo(nextPosition);
        },
        async loadData() {
            const { data } = await this.$http.get('/api/slider/projects');
            this.sliderItems = data;
        },
    },
    async beforeMount() {
        await this.loadData();
    },
};
</script>
